"use client";

import { GhostButton } from "@ui/buttons";
import { useTranslations } from "@i18n/provider";

type ConversationQuickActionProps = {
  onStart: () => void;
  disabled?: boolean;
};

export function ConversationQuickAction({ onStart, disabled }: ConversationQuickActionProps) {
  const { t } = useTranslations();

  return (
    <GhostButton
      onClick={onStart}
      disabled={disabled}
      className="mb-2 flex min-h-[44px] w-full items-center justify-center gap-2 bg-speaking-tint text-speaking-fg"
    >
      <span className="material-symbols-outlined text-lg" aria-hidden="true">
        forum
      </span>
      {t("agent.conversation.start")}
    </GhostButton>
  );
}
